import dayjs from 'dayjs'
import { FC } from 'react'

interface SubscriptionStatusDateProps {
  label: string
  date: string
}

export const SubscriptionStatusDate: FC<SubscriptionStatusDateProps> = ({ label, date }) => {
  return (
    <div className="flex items-center gap-2 mt-3">
      <span className=" text-xs leading-6 font-medium">{label} </span>
      <span className="text-xs leading-4 font-medium ">-</span>
      <span className="text-xs leading-4 font-medium ">{dayjs(date).format('MMM D, YYYY')}</span>
    </div>
  )
}
